import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppStore from '../../stores/app-store';
import AppActions from '../../actions/app-actions';

import TenantManagement from './tenant-management';
import DeviceManagement from './device-management';
import UserManagement from './user-management';
import { AppContext } from '../../contexts/app-context';

const routes = {
  tenant: {
    route: '/system-admin/tenant-management',
    status: 'tenant-management',
    title: 'Tenants'
  },
  device: {
    route: '/system-admin/device-management',
    status: 'device-management',
    title: 'Devices'
  },
  user: {
    route: '/system-admin/user-management',
    status: 'user-management',
    title: 'Users'
  }
};

export default class Configurations extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();  
  }

  _getInitialState() {
    return {
      tabIndex: this._updateActive(),
      snackbar: AppStore.getSnackbar(),
      hasMultitenancy: AppStore.hasMultitenancy()
    };
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({ tabIndex: this._updateActive() });
  }

  _onChange() {
    this.setState(this._getInitialState());
  }

  _updateActive(tab = this.context.router.route.match.params.tab) {
    if (routes.hasOwnProperty(tab)) {
      return routes[tab].route;
    }
    return routes.tenant.route;
  }

  _handleTabActive(tab) {
    var self = this;
    self.context.router.history.push(tab.props.value);
  }
  _changeTab(route) {
    var self = this;
    AppActions.setSnackbar('');
    self.context.router.history.push(route);
  }

  render() {

    const tabIndex = this.context.router.route.match.params.tab || 'tenant-management';
    return (
      <div style={{ marginTop: '-15px' }}>
        <Tabs value={tabIndex} onChange={() => this._changeTab.bind(this)}>
          <Tab component={Link} label={routes.tenant.title} value={routes.tenant.status} to={routes.tenant.route} />
          <Tab component={Link} label={routes.device.title} value={routes.device.status} to={routes.device.route} />
          <Tab component={Link} label={routes.user.title} value={routes.user.status} to={routes.user.route} />
        </Tabs>
        <AppContext.Consumer>
          {({ globalSettings, docsVersion }) => (
            <div>
              {tabIndex === routes.tenant.status && (
                <TenantManagement 
                  docsVersion={docsVersion}
                  globalSettings={globalSettings}
                />
              )}
              {tabIndex === routes.device.status && (
                <DeviceManagement />
              )}
              {tabIndex === routes.user.status && (
                <UserManagement />
              )}
            </div>
          )}
        </AppContext.Consumer>
      </div>
    )
  }
}
